import { API } from "./../../../api/config";

export const getAccountBalanceList= (params) => {
    return API.get(`/pmbpartner/account-balance-list/${params.partnerSK}`)
              .then((res) => res);
};

export const getAccountBalanceDetails= (params) => {
    return API.get("/pmbpartner/account-balance-details", { params })
              .then((res) => res);
};
